<template>
  <FaIcon :icon="['fas', !slash ? 'cloud' : 'cloud-slash' ]" />
</template>

<script setup lang="ts">
defineProps<{ slash?: boolean }>()
</script>
